import React from 'react';
import { Box, Typography } from 'housecall-ui';

import { ProgressBar } from './ProgressBar';

type Props = {
  currentStep: number;
  stepCount: number;
  showLabel?: boolean;
};

export const StepProgressBar = ({ currentStep, stepCount, showLabel = true }: Props) => {
  return (
    <div>
      {showLabel && (
        <Box mb={2}>
          <Typography variant="subtitle2">
            Step {currentStep} of {stepCount}
          </Typography>
        </Box>
      )}
      <ProgressBar value={currentStep} maxValue={stepCount} />
    </div>
  );
};
